import { defineMessages } from 'react-intl';

export const EstimationVersionsMessages = defineMessages({
  versionName: {
    id: 'estimationVersions.versionName',
    defaultMessage: 'Version Name',
  },
  status: {
    id: 'estimationVersions.status',
    defaultMessage: 'Status',
  },
  lastUpdated: {
    id: 'estimationVersions.lastUpdated',
    defaultMessage: 'Last Updated',
  },
  lastUpdatedBy: {
    id: 'estimationVersions.lastUpdatedBy',
    defaultMessage: 'Last Updated By',
  },
  createdAt: {
    id: 'estimationVersions.createdAt',
    defaultMessage: 'Created At',
  },
  createdBy: {
    id: 'estimationVersions.createdBy',
    defaultMessage: 'Created By',
  },
  estimate: {
    id: 'estimationVersions.estimate',
    defaultMessage: 'Estimate',
  },
});
